import { render, staticRenderFns } from "./VoteMessage.vue?vue&type=template&id=67d86992&scoped=true"
import script from "./VoteMessage.vue?vue&type=script&lang=js"
export * from "./VoteMessage.vue?vue&type=script&lang=js"
import style0 from "./VoteMessage.vue?vue&type=style&index=0&id=67d86992&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d86992",
  null
  
)

export default component.exports